import React from 'react';
import { defaultComponents } from '../Markdown/components/ReactMarkdown';
import { Markdown } from '../Markdown';
import { Typography } from '../Typography';
import { Box, BoxProps } from '../../wag-react/next-components/box';
export type ArticleBlockquoteProps = Omit<BoxProps, 'value'> & {
  value: string;
};
export const ArticleBlockquote = ({
  value,
  ...rest
}: ArticleBlockquoteProps) => <Box as="blockquote" backgroundColor="rgba(0,191,143,0.05)" borderRadius="12px" py="32px" px={['16px', '32px']} my="16px" mx="unset" {...rest} data-sentry-element="Box" data-sentry-component="ArticleBlockquote" data-sentry-source-file="index.tsx">
    <Markdown version="react-markdown" components={{
    ...defaultComponents,
    // Added eslint because we have to not grab the `node` argument
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    p: ({
      node,
      ...props
    }) => <Typography variant="body1" fontSize={['24px', null, '32px']} lineHeight={['40px', null, '48px']} color="darkGreen" textAlign="center" m={0} {...props} />
  }} data-sentry-element="Markdown" data-sentry-source-file="index.tsx">
      {value}
    </Markdown>
  </Box>;